module.exports = __webpack_public_path__ + "img/card-project6.cdb05aa3.jpg";